import classes from './Loading.module.css';

const Loading = () => {
    return <div className={classes['load-game']} />
}

export default Loading;